/**
 * useQualificationEntryScreen.js
 * ------------------------------
 * Hook for Qualification create/edit form screen using shared useMasterEntry.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as qualificationApi from '../api/qualificationApi';

export function useQualificationEntryScreen() {
  return useMasterEntry({
    entityName: 'Qualification',
    apiClient: qualificationApi.qualificationClient,
    fetchDetail: qualificationApi.getQualificationDetail,
    createItem: qualificationApi.createQualification,
    updateItem: qualificationApi.updateQualification,
    initialForm: {
      name: '',
      short_name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Qualification Name is required.';
      }
      return null;
    },
    listPath: '/masters/qualification/list',
    transformPayload: (form, operationalStatus) => ({
      name: form.name.trim(),
      short_name: form.short_name ? form.short_name.trim() : null,
      status: operationalStatus === 'active' ? 'Active' : 'Archived',
    }),
    transformDetail: (detail) => ({
      form: {
        name: detail.name || '',
        short_name: detail.short_name || '',
      },
      operationalStatus: detail.status === 'Active' ? 'active' : 'inactive',
    }),
  });
}
